// Medical aid tax credits for 2024-2025 tax year (identical to 2025-2026)
export const MEDICAL_AID_CREDITS_2024_25 = {
  mainMember: 364,        // R364 per month for main member
  firstDependent: 364,    // R364 per month for first dependent
  additionalDependent: 246 // R246 per month for each additional dependent
};

// Annual amounts (multiply monthly by 12)
export const ANNUAL_MEDICAL_AID_CREDITS_2024_25 = {
  mainMember: MEDICAL_AID_CREDITS_2024_25.mainMember * 12,           // R4,368
  firstDependent: MEDICAL_AID_CREDITS_2024_25.firstDependent * 12,   // R4,368
  additionalDependent: MEDICAL_AID_CREDITS_2024_25.additionalDependent * 12 // R2,952
};
